<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div *ngIf="dashboardUrl$ && dashboardUrl$ | async as dashboardUrl; else loading" class="dashboardContainer">
	<iframe
		#embedFrame
		(load)="onLoad($event, embedFrame)"
		(error)="onError($event)"
		[src]="dashboardUrl | safe"
		width="100%"
		height="100%"
		frameborder="0"
		scrolling="no"
	>
	</iframe>
</div>

<ng-template #loading>
	<div class="dashboardLoading">
		<!-- <h1>{{promptLoading}}</h1> -->
	</div>
</ng-template>
